export default {
  tag: 'Test',
  tag_tooltip: 'Restauracja testowa: w pełni działa, nigdy nie jest rozliczana.',
  card: {
    title: 'Restauracja testowa',
    description:
      'Oznacz jedną restaurację jako testową, aby wypróbować drukowanie, e-maile, zamówienia i integracje w środowisku produkcyjnym. Działa jak każda inna restauracja i nigdy nie jest rozliczana. E-maile i SMS-y do klientów o jej zamówieniach zaczynają się od [TEST].',
    payments_note:
      'Płatności w restauracji testowej są prawdziwe i wypłacane tak jak w każdej innej. Zwroty za testowe zamówienia wykonuj samodzielnie. Jesteśmy powiadamiani, gdy jej miesięczna sprzedaż przekroczy poziom testowy.',
    designated_on: 'Oznaczono jako testową {{date}}',
    open_shop: 'Otwórz sklep',
    remove: 'Usuń oznaczenie Test',
    select_placeholder: 'Wybierz restaurację',
    mark: 'Oznacz jako restaurację testową',
    no_restaurants: 'Nie masz jeszcze żadnej restauracji do oznaczenia.',
    load_error: 'Nie udało się wczytać Twojej restauracji testowej.',
  },
  remove_confirm: {
    title: 'Usunąć oznaczenie Test z {{name}}?',
    description_live:
      'Rozliczanie tej restauracji zostanie wznowione, a ona od razu przejdzie offline. Uruchom ją ponownie w Ustawienia zamówień → Metody zamówień → Zamówienia na żywo, gdzie wybierzesz jej plan.',
    description_stays_live:
      'Ta restauracja pozostaje aktywna i od teraz jest ponownie traktowana jak twoje pozostałe restauracje.',
    description_offline:
      'Rozliczanie tej restauracji zostanie wznowione, gdy przejdzie ona na żywo. Jej plan zostanie wybrany przy uruchomieniu.',
    confirm: 'Usuń oznaczenie Test',
  },
  toasts: {
    designated: '{{name}} jest teraz Twoją restauracją testową. Nie jest rozliczana.',
    designate_error: 'Nie udało się oznaczyć restauracji jako testowej. Spróbuj ponownie.',
    removed: '{{name}} nie jest już Twoją restauracją testową.',
    removed_offline: '{{name}} nie jest już Twoją restauracją testową i jest teraz offline.',
    remove_error: 'Nie udało się usunąć oznaczenia Test. Spróbuj ponownie.',
  },
};
